import axios from "axios";
export const API = {
    get: async function ({ url, params, config }) {
        const response = await axios.get(url, {
            params,
            ...config
        });
        return response.data;
    },
    post: async function ({ url, config, data }) {
        return await axios.post(url, data, config);
    },
};
//# sourceMappingURL=API.js.map